var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.6667L15 9.16667H9.16665C8.70641 9.16667 8.33331 8.79357 8.33331 8.33333V3.33333C8.33331 2.8731 8.70641 2.5 9.16665 2.5H16.6666C17.1269 2.5 17.5 2.8731 17.5 3.33333V11.6667",
    stroke: "#9E9B99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 12.4999V14.1666C11.6667 14.6268 11.2936 14.9999 10.8333 14.9999H5L2.5 17.4999V9.16659C2.5 8.70635 2.8731 8.33325 3.33333 8.33325H5",
    stroke: "#9E9B99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterview);
export default __webpack_public_path__ + "static/media/interview.1a4752af2d14fabb5970c385edb55d6c.svg";
export { ForwardRef as ReactComponent };